import defaultStyles from "./payment-terms-default.module.scss";
import mobileStyles from "./payment-terms-mobile.module.scss";
import DomPurify from "isomorphic-dompurify";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";

export function usePaymentTermCommon(staticPageContent: string) {
  const { t } = useTranslation();
  const { layoutType } = useLayoutType();

  const isMobile = layoutType === LayoutTypes.TYPE_MOBILE;
  const styles = isMobile ? mobileStyles : defaultStyles;

  const content = useMemo(() => {
    return DomPurify.sanitize(staticPageContent);
  }, [staticPageContent]);

  const renderContent = () => {
    const contentClassnames = classNames({
      [defaultStyles[LayoutStyleTypes.TYPE_SM]]: isMobile,
    });

    return (
      <div className={defaultStyles.wrapper}>
        <div className={styles.topcard}>
          <div className={styles.rowTitle}>
            <h1 className={styles.title}>{t("otstyqf59gqt6d8z.payment", "Payment")}</h1>
          </div>
        </div>
        <div className={contentClassnames} dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    );
  };

  return {
    renderContent
  };
}
